


















































import {Vue, Component} from 'vue-property-decorator'
import {Mutation} from "vuex-class";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {formatPrice} from "@/utils/formatters";

@Component({})
export default class AbcAnalizaKupaca extends mixins(ComponentBaseMixin) {
  @Mutation setPageSubtitle;
  isBusy = false;
  tableOptions = {
    pagination: false,
    search: true,
    sortable: true,
    pageSize: 20,
    loadingFontSize: `${14}px`,
    showExport: true,
    exportTypes: ['excel']
  };
  columns = [];
  analize = [];
  byQuantity = true
  abcResult = null;
  slider = [60, 80];

  async created() {
    this.columns = [
      {field: 'storeName', title: this.$i18n.t('kupac')},
      {field: 'total', title: this.$i18n.t('ukupno'), formatter: formatPrice, align: 'right', width: '120px'},
      {field: 'percentage', title: this.$i18n.t('ucesce'), formatter: (value) => formatPrice(value) + ' %', align: 'right', width: '120px'},
      {field: 'cumulativePercentage', title: this.$i18n.t('kumulativ'), formatter: (value) => formatPrice(value) + ' %', align: 'right', width: '120px'},
      {field: 'category', title: this.$i18n.t('kategorija'), sortable: true, align: 'right', width: '120px'},
    ];
  }

  async ucitajAnalize() {
    if (this.isBusy) return;
    console.log(this.slider);
    this.analize = [];
    let table = $('#abcAnalysysTable');
    this.isBusy = true;
    table.bootstrapTable('showLoading');
    await this.axios.get('/api/GetAbcAnalysis', {
      params: {
        byQuantity: this.byQuantity,
        a: this.slider[0],
        b: this.slider[1]
      }
    }).then(result => {
      this.abcResult = result.data;
      this.analize = result.data.records;
    }).catch(err => {
      this.showError('neuspesnoUcitavanjePodataka');
      table.bootstrapTable('hideLoading');
      this.isBusy = false;
    }).finally(() => {
      table.bootstrapTable('hideLoading');
      this.isBusy = false;
    })
  }

  async primeniKategorizaciju() {
    if (await this.confirmationNeeded('Da li želite da primenite rezultate ABC analize na prodajnu kategoriju objekata?')) {
      try {
        await this.$http.put(`/api/SetStoreCategoryBasedOnAbcAnalysis?a=${this.slider[0]}&b=${this.slider[1]}&byQuantity=${this.byQuantity}`);
        this.showInfo('podaciUspesnoSacuvani')
      } catch (e) {
        this.showError('neuspesnoCuvanjePodataka');
      }
    }

  }

  destroyed() {
    this.setPageSubtitle('');
  }
}
